import {
  renderBadActorsCardSection,
  renderBadActorsHitDetails,
} from "./ConductCheckDataReviewUtils.js";
import { getConductCheckData } from "./conductCheckUtils.js";

const ConductCheckDataReview = ({ data, onActionSelect, onActionUndo }) => {
  const conductCheckData = getConductCheckData(data);

  // For now there is no text for it. Wait for further clarifications.
  const infoText = 'TBD';

  return (
    <>
      {renderBadActorsCardSection(
        conductCheckData.badActors,
        "Bad actors",
        renderBadActorsHitDetails,
        <>
          {infoText}
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
    </>
  );
};

export default ConductCheckDataReview;
